export { default } from '@shikijs/langs/c'
